<template>
  <div class="mains">
    <a-row type="flex" justify="start">
      <a-col style="padding-left: 20px">
        <span>{{$t('userlang.Orgnization')}}</span>
        <a-select size="small" :showSearch="true" v-model="org" style="width: 200px;display:block" allowClear>
          <a-select-option v-for="item in orgs" :value="item.orgCode">{{item.displayName}}</a-select-option>
        </a-select>
      </a-col>
      <a-col style="padding-left: 20px">
        <span>{{$t('userlang.Project')}}</span>
        <a-select size="small" :showSearch="true" @dropdownVisibleChange="($event) =>{$event ? poejectDropChange() : null }" v-model="project" style="width: 200px;display:block" allowClear>
          <a-select-option v-for="item in projectsForOrg" :value="item.projectCode">{{item.displayName}}</a-select-option>
        </a-select>
      </a-col>
      <a-col style="padding-left: 20px">
        <span>{{$t('ediMast.ediType')}}</span>
        <a-input size="small" v-decorator="['ediType']" v-model="ediType" @pressEnter="query"/>
      </a-col>
      <a-col style="padding-left: 20px">
        <span>{{$t('ediMast.ediUid')}}</span>
        <a-input size="small" v-decorator="['ediUid']" v-model="ediUid" @pressEnter="query"/>
      </a-col>
      <a-col class="btn1" @click="query">
        <a-button type="primary" >{{ $t('pubGicSet.Search') }}</a-button>
      </a-col>
      <a-col class="btn1" @click="reset">
        <a-button type="primary" >{{ $t('pubGicSet.reset') }}</a-button>
      </a-col>
    </a-row>
    <a-divider style="margin: 5px 0" dashed/>
    <a-row type="flex" justify="start">
      <a-col align="left" style="width:50%">
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ $t('generic.Add') }}</span>
          </template>
          <img @click="addHdr()" class="sbxs" src="../../assets/img/ss-add.png" width="22" height="22">
        </a-tooltip>
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ $t('publicLang.Save') }}</span>
          </template>
          <img style="margin:0 4px" class="sbxs" src="../../assets/img/ss-save.png" @click="saveHeader" width="22" height="22">
        </a-tooltip>
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>Refresh</span>
          </template>
          <img class="sbxs ml4"  src="../../assets/img/ss-refresh.png" width="20" height="20" @click="query">
        </a-tooltip>
      </a-col>
      <a-col align="right" style="width:50%">
        <!--分页-->
        <a-pagination
            :pageSizeOptions="pageSizeOptions"
            :showTotal="total => $t('job.Total') + ` ${pagingTotal} `+$t('job.Records')"
            size="small"
            :total="pagingTotal"
            v-model="currentVal"
            :pageSize.sync="pagingSize"
            @change="tableChangePage"
            @showSizeChange="onShowSizeChange"
            :showSizeChanger="showSizeChanger"
            :showQuickJumper="showQuickJumper"
        />
      </a-col>
    </a-row>
    <a-row>
      <!--列表-->
      <vxe-table
          border
          resizable
          stripe
          column-key
          highlight-hover-column
          highlight-hover-row
          highlightCurrentRow
          show-header-overflow
          show-overflow
          max-height="130"
          :sort-config="{multiple: true, trigger: 'cell'}"
          :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
          :edit-rules="validHdrRules"
          keep-source
          :keyboard-config="{isArrow: true}"
          :radio-config="{trigger: 'row', highlight: true, range: true}"
          @radio-change="handleCheckboxChange"
          align="center"
          :data.sync="PagingGridList"
          class="mytable-style "
          ref="refHdrPagingGrid"
          size="mini">
        <template v-slot:empty>
          <a-empty></a-empty>
        </template>
        <vxe-table-column type="radio" width="35"></vxe-table-column>
        <vxe-table-column field="hostId" :title="$t('userlang.Orgnization')" width="220px" sortable :edit-render="{}"><!-- name:'$select',options:orgs,props:{clearable:true},events:{change:onOrgChange} -->
          <template v-slot:edit="{ row }">
            <select
                v-model="row.hostId"
                @change="onOrgChange(row)"
                style="width: 100%; padding: 4px 8px; border: 1px solid #dcdfe6; border-radius: 4px;"
                :disabled="!isRowEditable(row)"
                :class="{ 'disabled-select': !isRowEditable(row) }"
            >
              <option value=""></option>
              <option
                  v-for="org in orgs"
                  :key="org.orgCode"
                  :value="org.orgCode"
              >
                {{ org.displayName }}
              </option>
            </select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="workCenterCode" :title="$t('userlang.Project')" width="220px" sortable :edit-render="{}">
          <template v-slot:edit="{ row }">
            <select
                v-model="row.workCenterCode"
                style="width: 100%; padding: 4px 8px; border: 1px solid #dcdfe6; border-radius: 4px;"
                :disabled="!isRowEditable(row)"
                :class="{ 'disabled-select': !isRowEditable(row) }"
            >
              <option value=""></option>
              <option
                  v-for="project in getProjectsByHost(row.hostId)"
                  :key="project.projectCode"
                  :value="project.projectCode"
              >
                {{ project.displayName }}
              </option>
            </select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ediType" :title="$t('ediMast.ediType')" width="180px" sortable :edit-render="{}">
          <template v-slot:edit="{ row }">
            <input
                v-model="row.ediType"
                :disabled="!isRowEditable(row)"
                :class="{ 'disabled-input': !isRowEditable(row) }"
                style="width: 100%; border: 1px solid #dcdfe6; border-radius: 4px;"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column field="ediUid" :title="$t('ediMast.ediUid')" width="180px" sortable :edit-render="{}">
          <template v-slot:edit="{ row }">
            <input
                v-model="row.ediUid"
                :disabled="!isRowEditable(row)"
                :class="{ 'disabled-input': !isRowEditable(row) }"
                style="width: 100%; border: 1px solid #dcdfe6; border-radius: 4px;"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column field="filePrefix" :title="$t('ediMast.filePrefix')" width="180px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="fileExt" :title="$t('ediMast.fileExt')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="isUpload" :title="$t('ediMast.isUpload')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="ediAddress" :title="$t('ediMast.ediAddress')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="ediLogin" :title="$t('ediMast.ediLogin')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="ediPwd" :title="$t('ediMast.ediPwd')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="archiveDate" :title="$t('ediMast.archiveDate')" width="120px" sortable :edit-render="{name: 'input', attrs: {type: 'date'}}"></vxe-table-column>
        <vxe-table-column field="archiveAct" :title="$t('ediMast.archiveAct')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="lastRunTime" :title="$t('ediMast.lastRunTime')" width="120px" sortable :edit-render="{name: 'input', attrs: {type: 'date'}}"></vxe-table-column>
        <vxe-table-column field="isActive" :title="$t('ediMast.isActive')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="emailList" :title="$t('ediMast.emailList')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="allowUpd" :title="$t('ediMast.allowUpd')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="log2Db" :title="$t('ediMast.log2Db')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="processId" :title="$t('ediMast.processId')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="processLoginDate" :title="$t('ediMast.processLoginDate')" width="120px" sortable :edit-render="{name: 'input', attrs: {type: 'date'}}"></vxe-table-column>
        <vxe-table-column field="processRuntime" :title="$t('ediMast.processRuntime')" width="120px" sortable :edit-render="{name: 'input', attrs: {type: 'number', min: 0}}"></vxe-table-column>
        <vxe-table-column field="noOfRecords" :title="$t('ediMast.noOfRecords')" width="120px" sortable :edit-render="{name: 'input', attrs: {type: 'number', min: 0}}"></vxe-table-column>
        <vxe-table-column field="withPm" :title="$t('ediMast.withPm')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="priority" :title="$t('ediMast.priority')" width="120px" sortable :edit-render="{name: 'input', attrs: {type: 'number', min: 0}}"></vxe-table-column>
        <vxe-table-column field="hdrFlag" :title="$t('ediMast.hdrFlag')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="delimiter" :title="$t('ediMast.delimiter')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="mandatoryFieldList" :title="$t('ediMast.mandatoryFieldList')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="tableList" :title="$t('ediMast.tableList')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="multiWkc" :title="$t('ediMast.multiWkc')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="partrialUpload" :title="$t('ediMast.partrialUpload')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="withHdr" :title="$t('ediMast.withHdr')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="sftpPath" :title="$t('ediMast.sftpPath')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="sqlStatement" :title="$t('ediMast.sqlStatement')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="transmitType" :title="$t('ediMast.transmitType')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="attach" :title="$t('ediMast.attach')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="debugEmail" :title="$t('ediMast.debugEmail')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="auto" :title="$t('ediMast.auto')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="xsdFile" :title="$t('ediMast.xsdFile')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="dataKeepDays" :title="$t('ediMast.dataKeepDays')" width="120px" sortable :edit-render="{name: 'input', attrs: {type: 'number', min: 0}}"></vxe-table-column>
        <vxe-table-column field="subject" :title="$t('ediMast.subject')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="emailNoRecord" :title="$t('ediMast.emailNoRecord')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="endline" :title="$t('ediMast.endline')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="isFixedcolname" :title="$t('ediMast.isFixedcolname')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="archiveDir" :title="$t('ediMast.archiveDir')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="quotestr" :title="$t('ediMast.quotestr')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="isEmbedemail" :title="$t('ediMast.isEmbedemail')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="privateKey" :title="$t('ediMast.privateKey')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="convertType" :title="$t('ediMast.convertType')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="convertFile" :title="$t('ediMast.convertFile')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
      </vxe-table>
    </a-row>
    <a-divider style="margin: 5px 0" dashed/>
    <a-row type="flex" justify="start">
      <a-tooltip placement="topLeft">
        <template slot="title">
          <span>{{ $t('generic.Add') }}</span>
        </template>
        <img @click="addDtl" class="sbxs" src="../../assets/img/ss-add.png" width="22" height="22">
      </a-tooltip>
      <a-tooltip placement="topLeft">
        <template slot="title">
          <span>{{ $t('publicLang.Cancel') }}</span>
        </template>
        <img style="margin:0 4px" class="sbxs" src="../../assets/img/ss-delete.png" @click="deleteDtl" width="22" height="22">
      </a-tooltip>
      <a-tooltip placement="topLeft">
        <template slot="title">
          <span>{{ $t('publicLang.Save') }}</span>
        </template>
        <img style="margin:0 4px" class="sbxs" src="../../assets/img/ss-save.png" @click="saveDetail" width="22" height="22">
      </a-tooltip>
      <a-tooltip placement="topLeft">
        <template slot="title">
          <span>Refresh</span>
        </template>
        <img class="sbxs ml4"  src="../../assets/img/ss-refresh.png" width="20" height="20" @click="queryDtl">
      </a-tooltip>
    </a-row>
    <a-row>
      <!--列表-->
      <vxe-table
          border
          resizable
          stripe
          column-key
          highlight-hover-column
          highlight-hover-row
          highlightCurrentRow
          show-header-overflow
          show-overflow
          max-height="520"
          :sort-config="{multiple: true, trigger: 'cell'}"
          :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
          :edit-rules="validDtlRules"
          keep-source
          :keyboard-config="{isArrow: true}"
          :checkbox-config="{trigger: 'row', highlight: true, range: true}"
          align="center"
          :data.sync="PagingGridDtlList"
          class="mytable-style "
          ref="refDtlPagingGrid"
          size="mini">
        <template v-slot:empty>
          <a-empty></a-empty>
        </template>
        <vxe-table-column type="checkbox" width="35"></vxe-table-column>
        <vxe-table-column field="workCenterCode" :title="$t('userlang.Project')" width="120px" sortable></vxe-table-column>
        <vxe-table-column field="ediUid" :title="$t('ediMast.ediUid')" width="120px" sortable></vxe-table-column>
        <vxe-table-column field="ediType" :title="$t('ediMast.ediType')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="ediFieldSeq" :title="$t('ediMast.ediFieldSeq')" width="120px" sortable :edit-render="{name: 'input', attrs: {type: 'number', min: 0}}"></vxe-table-column>
        <vxe-table-column field="extColSeq" :title="$t('ediMast.extColSeq')" width="120px" sortable :edit-render="{name: 'input', attrs: {type: 'number', min: 0}}"></vxe-table-column>
        <vxe-table-column field="extColName" :title="$t('ediMast.extColName')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="sysColName" :title="$t('ediMast.sysColName')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="extColLen" :title="$t('ediMast.extColLen')" width="120px" sortable :edit-render="{name: 'input', attrs: {type: 'number', min: 0}}"></vxe-table-column>
        <vxe-table-column field="extDataType" :title="$t('ediMast.extDataType')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="startPos" :title="$t('ediMast.startPos')" width="120px" sortable :edit-render="{name: 'input', attrs: {type: 'number', min: 0}}"></vxe-table-column>
        <vxe-table-column field="endPos" :title="$t('ediMast.endPos')" width="120px" sortable :edit-render="{name: 'input', attrs: {type: 'number', min: 0}}"></vxe-table-column>
        <vxe-table-column field="mandatory" :title="$t('ediMast.mandatory')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="archiveDate" :title="$t('ediMast.archiveDate')" width="120px" sortable :edit-render="{name: 'input', attrs: {type: 'date'}}"></vxe-table-column>
        <vxe-table-column field="archiveAct" :title="$t('ediMast.archiveAct')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="defaultValue" :title="$t('ediMast.defaultValue')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="idCol" :title="$t('ediMast.idCol')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="ediFilePrefix" :title="$t('ediMast.ediFilePrefix')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="extDataFormat" :title="$t('ediMast.extDataFormat')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="ediDtlSeq" :title="$t('ediMast.ediDtlSeq')" width="120px" sortable :edit-render="{name: 'input', attrs: {type: 'number', min: 0}}"></vxe-table-column>
        <vxe-table-column field="isUpdatable" :title="$t('ediMast.isUpdatable')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="autoTruncate" :title="$t('ediMast.autoTruncate')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="cancelFlag" :title="$t('ediMast.cancelFlag')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="ref1" :title="$t('ediMast.ref1')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="ref2" :title="$t('ediMast.ref2')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="ref3" :title="$t('ediMast.ref3')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="ref4" :title="$t('ediMast.ref4')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="ref5" :title="$t('ediMast.ref5')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
        <vxe-table-column field="sysTableName" :title="$t('ediMast.sysTableName')" width="120px" sortable :edit-render="{name: 'input'}"></vxe-table-column>
      </vxe-table>
    </a-row>
  </div>
</template>

<script>
import ajax from "../../api/ajax";
import api from "../../api/url";


export default{
  data(){
    return{
      pagingTotal: 0, // 总数
      pagingSize:  20, // 条数
      currentVal: 1, // 当前选中的页数
      showSizeChanger:true,//是否显示页码下拉框
      showQuickJumper:false,//是否显示快速跳转输入框
      pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
      PagingGridList: [],//列表数据
      PagingGridDtlList: [],//列表数据
      leftTopHeight: 0,
      rightTopHeight: 0,
      ediMastHdr:null,
      ediMastDtl:null,
      validHdrRules: {
        hostId: [{ required: true, message: this.$t('job.notNull') }],
        workCenterCode: [{ required: true, message: this.$t('job.notNull') }],
        ediType: [{ required: true, message: this.$t('job.notNull') }],
        ediUid: [{ required: true, message: this.$t('job.notNull') }],
        isUpload: [{ required: true, message: this.$t('job.notNull') }],
        ediAddress: [{ required: true, message: this.$t('job.notNull') }],
        isActive: [{ required: true, message: this.$t('job.notNull') }],
        log2Db: [{ required: true, message: this.$t('job.notNull') }]
      },
      validDtlRules: {
        workCenterCode: [{ required: true, message: this.$t('job.notNull') }],
        ediType: [{ required: true, message: this.$t('job.notNull') }],
        ediUid: [{ required: true, message: this.$t('job.notNull') }],
        ediFieldSeq: [{ required: true, message: this.$t('job.notNull') }],
        extColSeq: [{ required: true, message: this.$t('job.notNull') }],
        extColLen: [{ required: true, message: this.$t('job.notNull') }],
        extDataType: [{ required: true, message: this.$t('job.notNull') }],
        mandatory: [{ required: true, message: this.$t('job.notNull') }],
        ediDtlSeq: [{ required: true, message: this.$t('job.notNull') }]
      },
      org:"",
      project:"",
      ediType:"",
      ediUid:"",
      orgs:[],
      projectsAll:[],
      projectsForOrg:[],
      projectOptions: {},
    }
  },
  created() {
    ajax.get(api.ORGANIAZTION).then(res => {
      this.orgs = res.data;
    });
    let params = {
      orgCode: ""
    };
    ajax.get(api.RULEPROJECT, params).then(res => {
      this.projectsAll = res.data;
      this.projectsForOrg = this.projectsAll;
      const grouped = res.data.reduce((acc, item) => {
        const key = item.orgCode;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      }, {});

      Object.keys(grouped).forEach(orgCode => {
        this.$set(this.projectOptions, orgCode, grouped[orgCode]);
      });
    });
  },
  methods:{
    query(){
      let Records = this.$refs.refHdrPagingGrid.getRecordset();
      let insertRecords = Records.insertRecords
      let updateRecords = Records.updateRecords
      let removeRecords = Records.removeRecords
      if(insertRecords.length > 0 || updateRecords.length > 0 || removeRecords.length > 0){
        let that = this;
        this.$customConfirm({
          title: that.$t('ediMast.dataNotSubmit'),
          okText: that.$t('publicLang.Confirm'),
          cancelText: that.$t('publicLang.Cancel'),
          content: "",
          onOk() {
            let params = {//配置查询条件
              org : that.org,
              project : that.project,
              ediType : that.ediType,
              ediUid : that.ediUid,
              currentVal : that.currentVal,
              pagingSize : that.pagingSize,
            }
            ajax.get(api.GETEDIMASTLIST,params).then(res=>{
              if(res.code == 200){
                that.PagingGridList = res.data;//列表
                that.pagingTotal = res.total;//总数
              }
            })
          }
        });
      }else{
        let params = {//配置查询条件
          org : this.org,
          project : this.project,
          ediType : this.ediType,
          ediUid : this.ediUid,
          currentVal : this.currentVal,
          pagingSize : this.pagingSize,
        }
        ajax.get(api.GETEDIMASTLIST,params).then(res=>{
          if(res.code == 200){
            this.PagingGridList = res.data;//列表
            this.pagingTotal = res.total;//总数
          }
        })
      }
    },
    isRowEditable(row) {
      if(null == row.createDate){
        return true;
      }else{
        return false;
      }
    },
    poejectDropChange() {
      this.projectsForOrg = this.projectOptions[this.org] || this.projectsAll;
    },
    onOrgChange(row) {
      return this.projectOptions[row.hostId] || this.projectsAll;
    },
    getProjectsByHost(hostId) {
      return this.projectOptions[hostId] || this.projectsAll;
    },
    cleardata(){
      this.reset();
    },
    reset(){
      this.org = "";
      this.project = "";
      this.ediType = "";
      this.ediUid = "";
    },
    addHdr(){
      let record = {
        seq: "",
        validSql: "",
        validParam: [],
        log2Db: "N",
        noOfRecords: 0,
        withPm: "N",
        priority: 999,
        emailNoRecord: "N",
        isFixedcolname: "N",
        isEmbedemail: "N"
      };
      this.$refs.refHdrPagingGrid
          .insert(record)
          .then(({ row }) => this.$refs.refHdrPagingGrid.setActiveRow(row));
    },
    addDtl(){
      const selectedRow = this.$refs.refHdrPagingGrid.getRadioRecord()
      if(!selectedRow){
        this.$customMessage.warning(this.$t('publicLang.PleaseFirst'), 2);
        return;
      }
      let record = {
        seq: "",
        validSql: "",
        validParam: [],
        workCenterCode: selectedRow.workCenterCode,
        ediUid: selectedRow.ediUid,
        ediType: "HDR",
        extColLen: 200,
        extDataType: "CHAR",
        mandatory: "N",
        idCol: "N",
        ediDtlSeq: 1
      };
      this.$refs.refDtlPagingGrid
          .insert(record)
          .then(({ row }) => this.$refs.refDtlPagingGrid.setActiveRow(row));
    },
    handleCheckboxChange({ row  }) {
      let Records = this.$refs.refDtlPagingGrid.getRecordset();
      let insertRecords = Records.insertRecords
      let updateRecords = Records.updateRecords
      let removeRecords = Records.removeRecords
      if(insertRecords.length > 0 || updateRecords.length > 0 || removeRecords.length > 0){
        let that = this;
        this.$customConfirm({
          title: that.$t('ediMast.dataNotSubmit'),
          okText: that.$t('publicLang.Confirm'),
          cancelText: that.$t('publicLang.Cancel'),
          content: "",
          onOk() {
            that.queryDetail(row.ediUid,row.workCenterCode);
          }
        });
      }else{
        this.queryDetail(row.ediUid,row.workCenterCode);
      }
    },
    queryDtl(){
      let Records = this.$refs.refDtlPagingGrid.getRecordset();
      let insertRecords = Records.insertRecords
      let updateRecords = Records.updateRecords
      let removeRecords = Records.removeRecords
      if(insertRecords.length > 0 || updateRecords.length > 0 || removeRecords.length > 0){
        let that = this;
        this.$customConfirm({
          title: that.$t('ediMast.dataNotSubmit'),
          okText: that.$t('publicLang.Confirm'),
          cancelText: that.$t('publicLang.Cancel'),
          content: "",
          onOk() {
            const selectedRow = that.$refs.refHdrPagingGrid.getRadioRecord()
            if(selectedRow){
              that.queryDetail(selectedRow.ediUid,selectedRow.workCenterCode);
            }else{
              that.$customMessage.warning(that.$t('publicLang.PleaseFirst'), 2);
              return;
            }
          }
        });
      }else{
        const selectedRow = this.$refs.refHdrPagingGrid.getRadioRecord()
        if(selectedRow){
          this.queryDetail(selectedRow.ediUid,selectedRow.workCenterCode);
        }else{
          this.$customMessage.warning(this.$t('publicLang.PleaseFirst'), 2);
          return;
        }
      }
    },
    queryDetail(ediUid,project){
      if(ediUid==null||ediUid==""){
        return;
      }
      let params = {//配置查询条件
        ediUid : ediUid,
        project : project,
      }
      ajax.get(api.GETEDIMASTDTLLIST,params).then(res=>{
        if(res.code == 200){
          this.PagingGridDtlList = res.data;//列表
        }
      })
    },
    saveDetail() {
      let Records = this.$refs.refDtlPagingGrid.getRecordset();
      let insertRecords = Records.insertRecords
      let updateRecords = Records.updateRecords
      let removeRecords = Records.removeRecords
      if (insertRecords.length == 0 && updateRecords.length == 0 && removeRecords.length == 0) {
        this.$customMessage.warning(this.$t('asnPage.saveData'), 2);
        return;
      }
      let checkRet = this.checkDtlRecords(insertRecords);
      if (!checkRet) {
        return;
      }
      checkRet = this.checkDtlRecords(updateRecords);
      if (!checkRet) {
        return;
      }
      let params = {
        insertRecords: insertRecords,
        updateRecords: updateRecords,
        removeRecords: removeRecords
      }
      ajax.post(api.SAVEEDIMASTDTL, params).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg, 2)
          const selectedRow = this.$refs.refHdrPagingGrid.getRadioRecord()
          if (selectedRow) {
            this.queryDetail(selectedRow.ediUid, selectedRow.workCenterCode);
          }
        } else {
          this.$customMessage.warning(res.msg, 2);
        }
      })
    },
    tableChangePage(current) {
      this.currentVal = current;
      this.query();
    },
    onShowSizeChange(current, pageSize) {//选择下拉框后触发事件
      this.currentVal = current;
      this.pagingSize = pageSize;
      this.query();
    },
    saveHeader() {
      let Records = this.$refs.refHdrPagingGrid.getRecordset();
      let insertRecords = Records.insertRecords
      let updateRecords = Records.updateRecords
      if (insertRecords.length == 0 && updateRecords.length == 0) {
        this.$customMessage.warning(this.$t('asnPage.saveData'), 2);
        return;
      }
      let checkRet = this.checkHdrRecords(insertRecords);
      if (!checkRet) {
        return;
      }
      checkRet = this.checkHdrRecords(updateRecords);
      if (!checkRet) {
        return;
      }
      let params = {
        insertRecords: insertRecords,
        updateRecords: updateRecords
      }
      ajax.post(api.SAVEEDIMAST, params).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg, 2)
          let params = {//配置查询条件
            org: this.org,
            project: this.project,
            ediType: this.ediType,
            ediUid: this.ediUid,
            currentVal: this.currentVal,
            pagingSize: this.pagingSize,
          }
          ajax.get(api.GETEDIMASTLIST, params).then(res => {
            if (res.code == 200) {
              this.PagingGridList = res.data;//列表
              this.pagingTotal = res.total;//总数
            }
          })
        } else {
          this.$customMessage.warning(res.msg, 2);
        }
      })
    },
    checkHdrRecords(records) {
      for (let i = 0; i < records.length; i++) {
        if (records[i].ediUid == null || records[i].ediUid.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediUid') + " " + this.$t('job.notNull'), 2);
          return false;
        }
        if (records[i].hostId == null || records[i].hostId.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediUid') + ":" + records[i].ediUid + ". " + this.$t('userlang.Orgnization') + " " + this.$t('job.notNull'), 2);
          return false;
        }
        if (records[i].workCenterCode == null || records[i].workCenterCode.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediUid') + ":" + records[i].ediUid + ". " + this.$t('userlang.Project') + " " + this.$t('job.notNull'), 2);
          return false;
        }
        if (records[i].ediType == null || records[i].ediType.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediUid') + ":" + records[i].ediUid + ". " + this.$t('ediMast.ediType') + " " + this.$t('job.notNull'), 2);
          return false;
        }
        if (records[i].isUpload == null || records[i].isUpload.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediUid') + ":" + records[i].ediUid + ". " + this.$t('ediMast.isUpload') + " " + this.$t('job.notNull'), 2);
          return false;
        }
        if (records[i].ediAddress == null || records[i].ediAddress.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediUid') + ":" + records[i].ediUid + ". " + this.$t('ediMast.ediAddress') + " " + this.$t('job.notNull'), 2);
          return false;
        }
        if (records[i].isActive == null || records[i].isActive.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediUid') + ":" + records[i].ediUid + ". " + this.$t('ediMast.isActive') + " " + this.$t('job.notNull'), 2);
          return false;
        }
        if (records[i].log2Db == null || records[i].log2Db.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediUid') + ":" + records[i].ediUid + ". " + this.$t('ediMast.log2Db') + " " + this.$t('job.notNull'), 2);
          return false;
        }
      }
      return true;
    },
    checkDtlRecords(records) {
      for (let i = 0; i < records.length; i++) {
        if (records[i].ediUid == null || records[i].ediUid.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediUid') + " " + this.$t('job.notNull'), 2);
          return false;
        }
        if (records[i].workCenterCode == null || records[i].workCenterCode.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediUid') + ":" + records[i].ediUid + ". " + this.$t('userlang.Project') + " " + this.$t('job.notNull'), 2);
          return false;
        }
        if (records[i].ediFieldSeq == null || records[i].ediFieldSeq.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediFieldSeq') + " " + this.$t('job.notNull'), 2);
          return false;
        }
        if (records[i].ediType == null || records[i].ediType.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediFieldSeq') + ":" + records[i].ediFieldSeq + ". " + this.$t('ediMast.ediType') + " " + this.$t('job.notNull'), 2);
          return false;
        }
        if (records[i].extColSeq == null || records[i].extColSeq.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediFieldSeq') + ":" + records[i].ediFieldSeq + ". " + this.$t('ediMast.extColSeq') + " " + this.$t('job.notNull'), 2);
          return false;
        }
        if (records[i].extColLen == null || records[i].extColLen.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediFieldSeq') + ":" + records[i].ediFieldSeq + ". " + this.$t('ediMast.extColLen') + " " + this.$t('job.notNull'), 2);
          return false;
        }
        if (records[i].extDataType == null || records[i].extDataType.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediFieldSeq') + ":" + records[i].ediFieldSeq + ". " + this.$t('ediMast.extDataType') + " " + this.$t('job.notNull'), 2);
          return false;
        }
        if (records[i].mandatory == null || records[i].mandatory.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediFieldSeq') + ":" + records[i].ediFieldSeq + ". " + this.$t('ediMast.mandatory') + " " + this.$t('job.notNull'), 2);
          return false;
        }
        if (records[i].ediDtlSeq == null || records[i].ediDtlSeq.length == 0) {
          this.$customMessage.warning(this.$t('ediMast.ediFieldSeq') + ":" + records[i].ediFieldSeq + ". " + this.$t('ediMast.ediDtlSeq') + " " + this.$t('job.notNull'), 2);
          return false;
        }
      }
      return true;
    },
    deleteDtl() {
      const Records = this.$refs.refDtlPagingGrid.getCheckboxRecords()
      if (Records.length == 0) {
        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 2);
        return;
      }
      let that = this;
      this.$customConfirm({
        title: that.$t('pubGicSet.AreyoudeleTask'),
        okText: that.$t('publicLang.Confirm'),
        cancelText: that.$t('publicLang.Cancel'),
        content: "",
        onOk() {
          that.$refs.refDtlPagingGrid.removeCheckboxRow()
        }
      });
    }
  }
}
</script>

<style lang="less">
.mains {
  height: 100%;
  width: 100%;
  padding: 10px;
  background-color: white;
}

.columns {
  width: 100%;
  height: 100%;
}

.btn1 {
  padding-left: 20px;
  padding-top: 10px;
}
</style>